import script from "./ClearBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClearBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ClearBtn.vue?vue&type=style&index=0&id=6d8af999&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8af999"]])

export default __exports__